'use client';

import { PageWrapper } from '@/components/layout/page-wrapper/page-wrapper';
import { PageHeader } from '@/components/layout/page-header/page-header';
import { ROUTES } from '@/shared/routes/routes';
import { Card, CardBody, Button } from '@nextui-org/react';
import { Instagram, Globe } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { cn } from '@/shared/utils/utils';


import React from 'react';
import { useIsAdmin } from '@/shared/hooks/is-admin';
import { useRouter } from 'next/navigation';

type SocialLink = {
  type: 'instagram' | 'vk' | 'telegram' | 'website';
  url: string;
};

type Author = {
  id: number;
  name: string;
  avatar?: string;
  socials: SocialLink[];
};

// Обновим моковые данные с реальными фотографиями
const blogPosts = [
  {
    id: 1,
    title: 'Подушка Сердце',
    description:
      'Связала подушку по мастер-классу. Подписывайтесь на мой Instagram, чтобы не пропустить новые работы!',
    date: '2024-02-14',
    author: {
      id: 1,
      name: 'Анна Петрова',
      socials: [
        {
          type: 'instagram' as const,
          url: 'https://instagram.com/anna_handmade',
        },
        { type: 'vk' as const, url: 'https://vk.com/anna_toys' },
      ],
    },
    images: [
      { id: 1, url: '/uploads/IMG_9637_3934aa9e0a.JPG' },

      { id: 2, url: '/uploads/IMG_0284_jpg_8df3baee9f.JPG' },

      { id: 3, url: '/uploads/IMG_0260_jpg_90dd2ab8ef.JPG' },

      { id: 4, url: '/uploads/IMG_9812_a645577e18.JPG' },

      {
        id: 5,
        url: '/uploads/beee784b_e921_4c60_958c_2675d7060108_618bee2d0d.JPG',
      },
    ],

    slug: 'heart-pillow',
  },
  {
    id: 2,
    title: 'Пряничный человечек',
    description:
      'Связала декоративную подушку Пряничный человечек. Теперь создает праздничную атмосферу в доме!',
    date: '2024-01-05',
    author: {
      id: 2,
      name: 'Мария Иванова',
      socials: [
        { type: 'telegram' as const, url: 'https://t.me/maria_crochet' },
        { type: 'website' as const, url: 'https://maria-toys.ru' },
      ],
    },
    images: [
      { id: 6, url: '/uploads/IMG_6712_jpg_731d104030.JPG' },

      { id: 7, url: '/uploads/IMG_7728_8844c05db4.JPG' },

      { id: 8, url: '/uploads/IMG_7727_260bb6ff48.JPG' },

      { id: 9, url: '/uploads/IMG_4363_jpg_2_9dd2047e80.JPG' },
    ],

    slug: 'gingerbread-man',
  },
  {
    id: 3,
    title: 'Весенние гномы',
    description:
      'Связала трех чудесных гномиков с весенними цветами. Они такие милые и позитивные!',
    date: '2024-03-01',
    author: {
      id: 3,
      name: 'Екатерина Смирнова',
      socials: [
        { type: 'instagram' as const, url: 'https://instagram.com/kate_toys' },
        { type: 'vk' as const, url: 'https://vk.com/kate_handmade' },
        { type: 'website' as const, url: 'https://kate-toys.com' },
      ],
    },
    images: [
      { id: 10, url: '/uploads/IMG_3764_611b0311c8.jpg' },

      { id: 11, url: '/uploads/IMG_4016_jpg_1b263a3867.jpg' },

      { id: 12, url: '/uploads/IMG_3165_a58a1955ba.JPG' },

      { id: 13, url: '/uploads/large_IMG_3165_a58a1955ba.JPG' },

      { id: 14, url: '/uploads/medium_IMG_3165_a58a1955ba.JPG' },
    ],

    slug: 'spring-gnomes',
  },
  {
    id: 4,
    title: 'Леденец - сладкая новогодняя подушка',
    description:
      'Создала яркую праздничную подушку-леденец. Дети в полном восторге, просят связать еще!',
    date: '2023-12-25',
    author: {
      id: 4,
      name: 'Ольга Николаева',
      socials: [
        {
          type: 'instagram' as const,
          url: 'https://instagram.com/olga_crochet',
        },
        { type: 'telegram' as const, url: 'https://t.me/olga_toys' },
      ],
    },
    images: [
      { id: 15, url: '/uploads/IMG_6109_3_de9707afea.jpg' },

      { id: 16, url: '/uploads/IMG_5897_jpg_2_82c658eedc.JPG' },

      { id: 17, url: '/uploads/IMG_5795_2_aa9d5bec97.JPG' },

      {
        id: 18,
        url: '/uploads/cf87d3f8_c10f_44ac_bbc5_36f99fc8bf9b_ab906e9ca8.JPG',
      },

      { id: 19, url: '/uploads/IMG_6107_3fd953442d.jpg' },
    ],

    slug: 'ledenets-podushka',
  },
  {
    id: 5,
    title: 'Маленький принц и его планета',
    description:
      'Воплотила в жизнь любимых персонажей из сказки. Маленький принц получился очень трогательным!',
    date: '2024-02-28',
    author: {
      id: 5,
      name: 'Татьяна Волкова',
      socials: [
        { type: 'vk' as const, url: 'https://vk.com/tanya_toys' },
        { type: 'website' as const, url: 'https://tanya-toys.ru' },
      ],
    },
    images: [
      {
        id: 20,
        url: '/uploads/090881_EF_1447_4_B8_B_950_D_59_F45_CC_50122_d1c0bca976.JPEG',
      },

      {
        id: 21,
        url: '/uploads/large_090881_EF_1447_4_B8_B_950_D_59_F45_CC_50122_d1c0bca976.JPEG',
      },

      {
        id: 22,
        url: '/uploads/medium_090881_EF_1447_4_B8_B_950_D_59_F45_CC_50122_d1c0bca976.JPEG',
      },
    ],

    slug: 'malenkiy-prints',
  },
  {
    id: 6,
    title: 'Оловянные солдатики - набор из трех игрушек',
    description:
      'Связала набор оловянных солдатиков для коллекционера. Каждый солдатик получился со своим характером!',
    date: '2024-01-15',
    author: {
      id: 6,
      name: 'Наталья Морозова',
      socials: [
        {
          type: 'instagram' as const,
          url: 'https://instagram.com/natali_crochet',
        },
        { type: 'telegram' as const, url: 'https://t.me/natali_toys' },
        { type: 'website' as const, url: 'https://t.me/natali_toys' },
        { type: 'vk' as const, url: 'https://t.me/natali_toys' },
      ],
    },
    images: [
      { id: 23, url: '/uploads/IMG_4464_2_bf05f4a0ea.JPG' },
      { id: 24, url: '/uploads/IMG_4177_jpg_413342a778.JPG' },
      { id: 25, url: '/uploads/IMG_4547_c006eb2f56.JPG' },
      { id: 26, url: '/uploads/IMG_4363_jpg_2_9dd2047e80.JPG' },
      { id: 27, url: '/uploads/IMG_4550_c4c6f2be5b.JPG' },
    ],

    slug: 'olovyannye-soldatiki',
  },
  {
    id: 7,
    title: 'Влюбленные слоники - милая парочка',
    description:
      'Связала пару влюбленных слоников. Идеальный подарок для влюбленных!',
    date: '2024-02-10',
    author: {
      id: 7,
      name: 'Алина Соколова',
      socials: [
        { type: 'vk' as const, url: 'https://vk.com/alina_handmade' },
        { type: 'website' as const, url: 'https://alina-toys.com' },
      ],
    },
    images: [
      { id: 28, url: '/uploads/image_15_02_22_02_56_a46287101d.jpeg' },
      { id: 29, url: '/uploads/image_15_02_22_02_57_3_423685fd14.jpeg' },
      { id: 30, url: '/uploads/image_26_03_20_10_24_medium2_b9a9bcb73a.png' },
      {
        id: 31,
        url: '/uploads/image_25_03_20_09_48_1_medium2_563583be9d.jpeg',
      },
    ],

    slug: 'vlyublennye-sloniki',
  },
  {
    id: 8,
    title: 'Пасхальные гномы - праздничное трио',
    description:
      'Создала трех пасхальных гномов с разными характерами. Они отлично дополняют друг друга!',
    date: '2024-03-15',
    author: {
      id: 8,
      name: 'Елена Кузнецова',
      socials: [
        { type: 'instagram' as const, url: 'https://instagram.com/elena_toys' },
        { type: 'telegram' as const, url: 'https://t.me/elena_crochet' },
      ],
    },
    images: [
      { id: 32, url: '/uploads/image_09_06_23_10_48_d475f65f9a.jpeg' },
      { id: 33, url: '/uploads/image_20_09_24_11_30_1_c8b989cd74.jpeg' },
      { id: 34, url: '/uploads/image_08_06_23_09_01_8_e0d80e84b2.jpeg' },
      { id: 35, url: '/uploads/image_08_06_23_09_01_7_fe5beb476c.jpeg' },
      { id: 36, url: '/uploads/image_08_06_23_09_01_4_18d969e0d3.jpeg' },
    ],

    slug: 'pashalnye-gnomy',
  },
  {
    id: 9,
    title: 'Птичка - новогодний декор',
    description:
      'Связала милую птичку для новогодней елки. Получилась очень нежная и воздушная игрушка!',
    date: '2023-12-20',
    author: {
      id: 9,
      name: 'Ирина Попова',
      socials: [
        { type: 'vk' as const, url: 'https://vk.com/irina_crochet' },
        { type: 'website' as const, url: 'https://irina-toys.ru' },
      ],
    },
    images: [
      { id: 37, url: '/uploads/zagruzheno_2_7b4336a8ef.png' },

      { id: 38, url: '/uploads/zagruzheno_1_9bf5c4cfce.png' },

      { id: 39, url: '/uploads/zagruzheno_3_490b26402b.png' },

      { id: 40, url: '/uploads/zagruzheno_4_1_4c97ae48fa.png' },
    ],

    slug: 'ptichka-novogodnyaya',
  },
  {
    id: 10,

    title: 'Пряня - новогодний персонаж',
    description:
      'Связала пряничного человечка для новогодних фотосессий. Он получился таким душевным и уютным!',
    date: '2023-12-15',
    author: {
      id: 10,
      name: 'Светлана Белова',
      socials: [
        { type: 'instagram' as const, url: 'https://instagram.com/sveta_toys' },
        { type: 'telegram' as const, url: 'https://t.me/sveta_crochet' },
        { type: 'website' as const, url: 'https://sveta-toys.com' },
      ],
    },
    images: [
      { id: 41, url: '/uploads/IMG_8594_jpg_f4f8c839e0.JPG' },
      {
        id: 42,
        url: '/uploads/34214047_5_E04_45_FE_890_F_AF_1061070_DF_4_1a348f4db0.JPEG',
      },
      { id: 43, url: '/uploads/IMG_8545_b1b0a384b9.JPG' },
      { id: 44, url: '/uploads/IMG_6714_jpg_59df6b45ae.JPG' },
      { id: 45, url: '/uploads/large_IMG_8594_jpg_f4f8c839e0.JPG' },
    ],

    slug: 'pryanichnyy-chelovechek-igrushka',
  },
];

const PhotoGallery = ({
  images,
  author,
}: {
  images: Array<{ url: string; id: number }>;
  author: Author;
}) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  const renderImage = (image: (typeof images)[0], additionalClasses = '') => (
    <figure className={`relative w-full h-full ${additionalClasses}`}>
      <Image
        src={image.url}
        alt="Фотография работы"
        fill
        className="object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
        placeholder="blur"
        blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkMjU1LC0yMi4xODY6NT47Pi0uRGhFS1NWW1xbMkFlbWRYbFBZW1f/2wBDARUXFx4aHR4eHVdRLy8vV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1f/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
        loading="lazy"
      />
    </figure>
  );

  const authorInfo = (
    <div className="fixed items-center w-auto justify-center left-1/2 -translate-x-1/2 bottom-2 z-30">
      <div className="flex items-center gap-2 bg-black/50 px-4 py-2 rounded-full">
        <span className="text-sm text-white">{author.name}</span>
        <SocialLinks socials={author.socials} inPhotoView />
      </div>
    </div>
  );

  if (!isMounted) {
    return (
      <div className="w-full aspect-[16/9] bg-default-100 animate-pulse rounded-lg" />
    );
  }

  return (
    <PhotoProvider maskOpacity={0.8} toolbarRender={() => authorInfo}>
      <div className="grid grid-cols-2 gap-4 aspect-[16/9] relative">
        {images.map((image, index) => (
          <PhotoView key={image.id} src={image.url}>
            {index < 4 ? (
              <div className="relative aspect-square w-full group cursor-pointer">
                {renderImage(image)}
                {index === 3 && images.length > 4 && (
                  <div className="text-center absolute inset-0 bg-gradient-to-b from-black/0 via-black/40 rounded-lg flex items-center justify-center z-10 text-white text-4xl">
                    <div className="bg-black-700 p-4 w-auto rounded-lg">
                      +{images.length - 4}
                    </div>
                  </div>
                )}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors rounded-lg" />
                <div
                  className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/60 via-black/40 to-transparent rounded-t-2xl"
                  style={{ height: '4rem' }}
                >
                  <div className="flex items-center md:flex-row flex-col gap-2 p-2">
                    <span className="text-sm text-white font-medium">
                      {author.name}
                    </span>
                    <SocialLinks socials={author.socials} inPhotoView />
                  </div>
                </div>
              </div>
            ) : (
              <span />
            )}
          </PhotoView>
        ))}
      </div>
    </PhotoProvider>
  );
};

// Компонент для отображения социальных ссылок
const SocialLinks = ({
  socials,
  inPhotoView,
}: {
  socials: SocialLink[];
  inPhotoView?: boolean;
}) => {
  const getSocialIcon = (type: SocialLink['type']) => {
    const buttonClasses = cn(
      'min-w-0 w-8 h-8',
      inPhotoView && 'text-white hover:text-white',
    );

    switch (type) {
      case 'instagram':
        return (
          <Button
            as="a"
            href={socials[0].url}
            target="_blank"
            rel="noopener noreferrer"
            isIconOnly
            variant="light"
            size="sm"
            className={buttonClasses}
          >
            <Instagram size={16} />
          </Button>
        );
      case 'vk':
        return (
          <Button
            as="a"
            href="https://vk.com"
            target="_blank"
            rel="noopener noreferrer"
            isIconOnly
            variant="light"
            size="sm"
            className={buttonClasses}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93V15.07C2 20.67 3.33 22 8.93 22H15.07C20.67 22 22 20.67 22 15.07V8.93C22 3.33 20.67 2 15.07 2ZM18.15 16.27H16.69C16.14 16.27 15.97 15.82 14.86 14.72C13.86 13.77 13.49 13.67 13.27 13.67C12.95 13.67 12.87 13.76 12.87 14.18V15.77C12.87 16.08 12.75 16.27 11.81 16.27C10.26 16.27 8.57 15.32 7.33 13.59C5.45 11 4.97 9.03 4.97 8.67C4.97 8.45 5.05 8.26 5.47 8.26H6.94C7.26 8.26 7.4 8.43 7.54 8.82C8.42 11.19 9.9 13.22 10.37 13.22C10.57 13.22 10.65 13.13 10.65 12.66V10.09C10.6 9.08 10.19 9.01 10.19 8.7C10.19 8.53 10.33 8.26 10.56 8.26H12.97C13.24 8.26 13.37 8.43 13.37 8.8V12.13C13.37 12.4 13.53 12.53 13.63 12.53C13.83 12.53 14 12.4 14.32 12.08C15.39 10.91 16.16 9.11 16.16 9.11C16.25 8.89 16.42 8.69 16.76 8.69H18.23C18.62 8.69 18.72 8.93 18.62 9.27C18.4 10.41 16.63 12.91 16.63 12.91C16.43 13.24 16.37 13.38 16.63 13.72C16.83 13.97 17.4 14.47 17.79 14.92C18.5 15.73 19.07 16.42 19.21 16.83C19.35 17.23 19.13 17.27 18.15 17.27V16.27Z" />
            </svg>
          </Button>
        );
      case 'telegram':
        return (
          <Button
            as="a"
            href="https://telegram.org"
            target="_blank"
            rel="noopener noreferrer"
            isIconOnly
            variant="light"
            size="sm"
            className={buttonClasses}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22 3.1L19.08 20.85C18.87 21.96 18.27 22.22 17.32 21.68L12.13 17.94L9.64001 20.34C9.41001 20.57 9.22001 20.76 8.78001 20.76L9.08001 15.47L18.4 7.06C18.75 6.75 18.33 6.57 17.88 6.88L6.50001 14.13L1.35001 12.51C0.260007 12.16 0.240007 11.47 1.57001 10.93L20.66 3.07C21.57 2.72 22.37 3.22 22 3.1Z" />
            </svg>
          </Button>
        );
      case 'website':
        return (
          <Button
            as="a"
            href="https://website.com"
            target="_blank"
            rel="noopener noreferrer"
            isIconOnly
            variant="light"
            size="sm"
            className={buttonClasses}
          >
            <Globe size={16} />
          </Button>
        );
    }
  };

  return (
    <div className="flex gap-1">
      {socials.map((social) => (
        <div key={social.url}>{getSocialIcon(social.type)}</div>
      ))}
    </div>
  );
};

export default function BlogPage() {
  const [isMounted, setIsMounted] = React.useState(false);
  const { isAdmin } = useIsAdmin();
  const router = useRouter();

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  React.useEffect(() => {
    if (!isAdmin) {
      router.push(ROUTES.home);
    }
  }, [isAdmin, router]);

  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <h2 className="text-center text-lg bg-red-100">тестовая страница</h2>
      <PageWrapper>
        {/* был <main>, но единственный main теперь в (ru)/layout */}
        <div>
          {isMounted && (
            <div className="mb-8 hidden md:block">
              <PageHeader
                title="Работы подписчиков"
                subTitle="Делимся вашими успехами в вязании игрушек"
              />
            </div>
          )}

          <div
            className={cn(
              'grid grid-cols-1 gap-6',
              !isMounted && 'opacity-0',
              isMounted && 'opacity-100 transition-opacity duration-300',
            )}
          >
            {blogPosts.map((post) => (
              <article key={post.id}>
                <Card className="hover:shadow-2xl transition-all duration-300 w-full border-2 border-transparent hover:border-primary/20">
                  <CardBody className="p-6 relative">
                    <time
                      dateTime={post.date}
                      className="absolute top-2 right-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {new Date(post.date).toLocaleDateString('ru-RU')}
                    </time>

                    <header className="mb-4">
                      <h2 className="text-2xl font-semibold mb-2">
                        <Link
                          href={`/blog/${post.slug}`}
                          className="text-gray-900"
                        >
                          {post.title}
                        </Link>
                      </h2>
                      <div className="flex items-center gap-4">
                        <span className="text-sm text-gray-600">
                          {post.author.name}
                        </span>
                        <SocialLinks socials={post.author.socials} />
                      </div>
                    </header>

                    <div className="mb-4">
                      <p className="text-gray-600 text-lg">
                        {post.description}
                      </p>
                    </div>

                    <figure>
                      <PhotoGallery images={post.images} author={post.author} />
                      <figcaption className="sr-only">
                        {`Галерея фотографий для поста "${post.title}"`}
                      </figcaption>
                    </figure>
                  </CardBody>
                </Card>
              </article>
            ))}
          </div>
        </div>
      </PageWrapper>
    </>
  );
}
